import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Header from "@/components/eHeader.vue";
import Header2 from "@/components/eHeader2.vue";
import Footer from "@/components/eFooter.vue";
import { useRouter } from "vue-router";
import { watch, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userRouter = useRouter();
const bg_show = ref(true);

const routePath = ref();
watch(
  () => userRouter.currentRoute.value.fullPath,
  (val: string) => {
    if (
      (val.split("/")[0] === "" && val.split("/")[1] === "") ||
      val.split("/")[1] === "solution" ||
      val.split("/")[1] === "coreTechnology" ||
      val.split("/")[1] === "about" ||
      val.split("/")[1] === "zoology" ||
      val.split("/")[1] === "productService"
    ) {
      bg_show.value = true;
    } else {
      routePath.value = val;
      bg_show.value = false;
    }
    document.documentElement.scrollTop = 0;
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (bg_show.value)
      ? (_openBlock(), _createBlock(Header, {
          key: 0,
          routePath: routePath.value
        }, null, 8, ["routePath"]))
      : (_openBlock(), _createBlock(Header2, {
          key: 1,
          routePath: routePath.value
        }, null, 8, ["routePath"])),
    _createVNode(_component_router_view),
    _createVNode(Footer)
  ], 64))
}
}

})